import React from 'react';
import { useParams } from 'react-router-dom';
import PatientIntakeForm from './patientIntake/PatientIntakeForm';

const PatientEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const patientId = id ? Number.parseInt(id, 10) : null;

  if (!patientId || !Number.isInteger(patientId)) {
    return null;
  }

  return <PatientIntakeForm patientId={patientId} />;
};

export default PatientEdit;
